import { motion } from 'motion/react'
import { SVGProps } from 'react'

interface AnimatedIconProps extends SVGProps<SVGSVGElement> {
	isActive?: boolean
}

export default function AnimatedMagnifierIcon({ isActive, ...props }: AnimatedIconProps) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<motion.path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.5 19C15.6421 19 19 15.6421 19 11.5C19 7.35786 15.6421 4 11.5 4C7.35786 4 4 7.35786 4 11.5C4 15.6421 7.35786 19 11.5 19Z"
					stroke="var(--tint-primary)"
					strokeWidth="2.1"
					fill="none"
					animate={{
						strokeWidth: isActive ? 3 : 2.1,
					}}
					transition={{
						duration: 0.2,
					}}
				/>
				<motion.path
					d="M21 21L17 17.5"
					stroke="var(--tint-primary)"
					strokeWidth="2.1"
					strokeLinecap="round"
					animate={{
						strokeWidth: isActive ? 3 : 2.1,
					}}
					transition={{
						duration: 0.2,
					}}
				/>
			</g>
		</svg>
	)
}
